export const SDK_VERSION = '2.1.19';
